'use client';

import { OAuthProvider } from 'src/modules/auth/providers/oauth-provider/oauth-provider';

import React from 'react';

type AuthProviderContextType = {
  authorizedOrganizationId: string | null;
  setAuthorizedOrganizationId: (organizationId: string) => void;
};

const AuthProviderContext = React.createContext<AuthProviderContextType>(
  {
    authorizedOrganizationId: null,
    setAuthorizedOrganizationId: () => { throw new Error('Context not initalized'); },
  },
);

export const AuthProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [authorizedOrganizationId, setAuthorizedOrganizationId] = React.useState<string | null>(null);

  const context: AuthProviderContextType = React.useMemo(() => ({
    authorizedOrganizationId,
    setAuthorizedOrganizationId,
  }), [authorizedOrganizationId, setAuthorizedOrganizationId]);

  return (
    <AuthProviderContext.Provider value={context}>
      <OAuthProvider>{children}</OAuthProvider>
    </AuthProviderContext.Provider>
  );
};

export const useAuthProvider = (): AuthProviderContextType => React.useContext(AuthProviderContext);
